export default __webpack_public_path__ + "static/media/XS4 Original.bbacd61f.jpg";